import { render, staticRenderFns } from "./StatusChain.vue?vue&type=template&id=359c715a&scoped=true&"
import script from "./StatusChain.vue?vue&type=script&lang=ts&"
export * from "./StatusChain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c715a",
  null
  
)

export default component.exports